import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';
import { API_BASE_URL } from './config';

const HomePage = () => {
  const navigate = useNavigate();

  const handleLoginSuccess = async (credentialResponse) => {
    try {
      const res = await axios.post(
        `${API_BASE_URL}/auth/google/`,
        { token: credentialResponse.credential }
      );
      
      console.log("Respuesta del Backend:", res.data);
      localStorage.setItem('user', JSON.stringify(res.data));
      navigate('/dashboard');
      
    } catch (error) {
      console.error("Error al enviar el token al backend:", error);
      alert("Hubo un error al iniciar sesión. Revisa la consola.");
    }
  };

  const handleLoginError = () => {
    console.log('Login Fallido');
  };

  return (
    <div className="homepage-container">
      {/* --- NAVBAR --- */}
      <nav className="navbar">
        {/* --- NAVBAR --- */}
        <div className="logo-container">
           {/* CAMBIO: Solo la imagen, más grande (60px en vez de 40px) y sin el texto al lado */}
           <img src="/logo.png" alt="WILSYNC" style={{ height: '60px' }} />
        </div>
        <div className="nav-actions">
           <button className="btn-secondary" onClick={() => document.getElementById('login-section').scrollIntoView({behavior: 'smooth'})}>
             Cómo funciona
           </button>
        </div>
      </nav>

      {/* --- HERO SECTION --- */}
      <header className="hero-section">
        <div className="hero-content">
          <span className="badge-new">Nuevo: Integración con Instagram 🚀</span>
          <h1>Tu Community Manager <span className="gradient-text">Autónomo con IA</span></h1>
          <p className="hero-subtitle">
            Conecta tus páginas de Facebook e Instagram. Define tu producto una sola vez y deja que 
            nuestra IA genere imágenes, redacte textos y publique por ti todos los días.
          </p>
          
          <div className="cta-wrapper" id="login-section">
            <p className="cta-label">Empieza gratis con tu cuenta de Google:</p>
            <div className="google-btn-wrapper">
               <GoogleLogin 
                 onSuccess={handleLoginSuccess} 
                 onError={handleLoginError} 
                 theme="filled_blue"
                 shape="pill"
                 size="large"
                 text="continue_with"
               />
            </div>
          </div>
        </div>
        
        <div className="hero-visual">
          {/* CAMBIO: Imagen Real cards.jpg */}
          <div className="dashboard-preview-card" style={{ padding: 0, overflow: 'hidden', border: 'none', background: 'transparent' }}>
             <img 
                src="/cards.jpg" 
                alt="Wilsync Dashboard Preview" 
                style={{ width: '100%', height: 'auto', borderRadius: '12px', boxShadow: '0 20px 40px rgba(0,0,0,0.2)' }} 
             />
          </div>
        </div>
      </header>

      {/* --- FEATURES SECTION --- */}
      <section className="features-section">
        <div className="section-header">
           <h2>Todo lo que necesitas para vender en redes</h2>
           <p>Tecnología de punta simplificada para tu negocio.</p>
        </div>
        
        <div className="features-grid">
           <div className="feature-card">
              <div className="icon-box">🎨</div>
              <h3>Diseño IA Generativo</h3>
              <p>Olvídate de buscar fotos de stock. Creamos imágenes únicas de tus productos usando DALL-E 3 y Gemini Pro.</p>
           </div>
           
           <div className="feature-card">
              <div className="icon-box">✍️</div>
              <h3>Copywriting Persuasivo</h3>
              <p>Redacción automática de posts optimizada para ventas, con emojis y hashtags relevantes para tu nicho.</p>
           </div>

           <div className="feature-card">
              <div className="icon-box">📅</div>
              <h3>Planificador "Set & Forget"</h3>
              <p>Define tus horarios de publicación y el sistema trabajará 24/7 sin que tengas que mover un dedo.</p>
           </div>
        </div>
      </section>

      {/* --- FOOTER --- */}
      <footer className="homepage-footer">
        <div className="footer-content">
          <p>© 2025 WILSYNC Inc. Todos los derechos reservados.</p>
          
          {/* CAMBIO: Correo de soporte agregado */}
          <div className="footer-contact" style={{ margin: '10px 0', color: '#888' }}>
            <span style={{ marginRight: '5px' }}>📧</span>
            <a href="mailto:soporte@wilsync.com" style={{ color: '#6366f1', textDecoration: 'none' }}>soporte@wilsync.com</a>
          </div>

          <div className="footer-links">
             <span>Privacidad</span>
             <span>Términos</span>
             <span>Soporte</span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;